export default __webpack_public_path__ + "static/media/rift1.4505792e.mp3";